@import '../styles/_vars.css';

.sectionTextImage {
  padding-top: 1em;
  padding-bottom: 2.5em;
}

.textImage {
  display: flex;
  justify-content: flex-start;
  column-gap: 1rem;
  row-gap: 1rem;
  flex-direction: column;
}

.left {
  text-align: center;
}

.left img {
  display: inline-block;
  max-height: 300px;
  width: auto;
}

.right h2 {
  margin-bottom: .8em;
}

.right {
  padding: 1rem;
}

.right a {
  text-decoration: none;
}


@media screen and (min-width: 770px) {
  .sectionTextImage {
    padding-top: 5em;
  }

  .textImage {
    flex-direction: row;
    align-items: center;
    padding: 0 0 0 10px;
  }

  .left {
    width: 50%;
  }

  .left img {
    display: block;
    max-height: none;
    width: 100%;
    max-width: 429px;
    height: auto
  }

  .right {
    text-align: left;
    width: 50%;
  }
}


@media screen and (min-width: 1180px) {
  .textImage {
    column-gap: 5.5em;
  }

  .left {
    display: block;
    width: 430px;
  }

  .left img {
    width: auto;
  }

  .right {
    width: 100%;
  }
}
